import { useEffect, Component } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Founder from "@/components/Founder";
import Projects from "@/components/Projects";
import KnightsCourt from "@/components/KnightsCourt";
import Process from "@/components/Process";
import Engagement from "@/components/Engagement";
import Testimonials from "@/components/Testimonials";
import Vendors from "@/components/Vendors";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-8 text-center">
          <div>
            <p className="font-serif text-3xl text-[#1A1918]">The Studio31</p>
            <p className="text-[#8C837A] mt-3 text-sm">Something went wrong. Please refresh the page.</p>
            <button
              data-testid="error-reload-button"
              onClick={() => window.location.reload()}
              className="mt-6 bg-[#1A1918] text-[#FDFBF7] px-8 py-3 text-sm hover:bg-[#C5A059] hover:text-[#1A1918] transition-colors"
            >
              Refresh
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf = requestAnimationFrame(function loop(t) {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    });
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="bg-cream text-ink font-sans">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Founder />
          <Projects />
          <KnightsCourt />
          <Process />
          <Engagement />
          <Testimonials />
          <Vendors />
          <Contact />
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1A1918",
              color: "#FDFBF7",
              border: "1px solid rgba(197,160,89,0.4)",
              borderRadius: 0,
            },
          }}
        />
      </div>
    </ErrorBoundary>
  );
}
